import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Layout, Banner} from '@shopify/polaris';

class ErrorBanner extends React.PureComponent {
  render() {
    const {error} = this.props;

    if (!error) {
      return null;
    }

    const {
      title = 'Something went wrong',
      message = 'An unexpected application error occurred.',
    } = error;
    const bannerAction = this.getBannerAction();

    return (
      <Layout>
        <Layout.Section>
          <Banner title={title} status="critical" action={bannerAction}>
            <p>{message}</p>
          </Banner>
        </Layout.Section>
      </Layout>
    );
  }

  getBannerAction() {
    const {error} = this.props;
    const {ctaUrl, ctaText} = error || {};

    return ctaUrl && ctaText
      ? {
          content: ctaText,
          url: ctaUrl,
          external: true,
        }
      : null;
  }
}

function mapStateToProps(store) {
  const {
    progress: {error},
  } = store;

  return {error};
}

export default connect(mapStateToProps)(ErrorBanner);

ErrorBanner.propTypes = {
  error: PropTypes.object,
};
